import { render, staticRenderFns } from "./Voortgang.vue?vue&type=template&id=1cad0420&"
import script from "./Voortgang.vue?vue&type=script&lang=js&"
export * from "./Voortgang.vue?vue&type=script&lang=js&"
import style0 from "./Voortgang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports